import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";


interface FaqItem {
    question: string;
    answer: string | JSX.Element;
}

interface FaqSectionProps {
    title: string;
    items: FaqItem[];
}

const FaqSection: React.FC<FaqSectionProps> = ({ title, items }) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const toggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="mb-8 w-full md:w-1/2 px-4">
            <h2 className="text-lg font-bold text-gray-600  dark:text-gray-300 mb-4">{title}</h2>
            {items.map((item, index) => (
                <div key={index} className="border-b border-gray-200 dark:border-gray-400 py-3">
                    <button
                        className="group w-full text-left flex justify-between items-center font-medium text-gray-700 dark:text-gray-300 transition"
                        onClick={() => toggle(index)}
                    >
                        <span className="text-sm group-hover:text-orange-500 transition">{item.question}</span>
                        {openIndex === index ? (
                            <MinusIcon className="w-4 h-4 group-hover:text-orange-500 transition" />
                        ) : (
                            <PlusIcon className="w-4 h-4 group-hover:text-orange-500 transition" />
                        )}
                    </button>

                    {openIndex === index && (
                        <div className="mt-2 text-xs text-gray-600 dark:text-gray-500">{item.answer}</div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FaqSection;
